<template>
    <v-container class="my-2 px-0 counter-nav">
        <v-row no-gutters>
            <v-col v-if="prevName" class="flex-grow-0 flex-shrink-1">
                <v-btn data-id="prev-stop" variant="text" flat height="55" class="text-none pa-1" @click="handleClick('prev')">
                    <v-icon size="55"> mdi-chevron-left </v-icon>
                    <p style="max-width: 110px" class="body-2 text-truncate mb-0">
                        {{ prevName }}
                    </p>
                </v-btn>
            </v-col>
            <v-spacer />
            <v-col v-if="nextName" class="flex-grow-0 flex-shrink-1">
                <v-btn data-id="next-stop" variant="text" flat height="55" class="text-none pa-1" @click="handleClick('next')">
                    <p style="max-width: 110px" class="body-2 text-truncate mb-0">
                        {{ nextName }}
                    </p>
                    <v-icon size="55"> mdi-chevron-right </v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts" setup>
defineProps<{
    prevName?: string;
    nextName?: string;
}>();

const emit = defineEmits(['prev', 'next']);

const handleClick = event => {
    emit(event);
};
</script>

<style lang="scss" scoped>
.v-icon {
    width: 35px;
    height: 45px;
    overflow: hidden;
}
</style>
